import { render } from "./CardMenuSimple.vue?vue&type=template&id=65943f6c"
import script from "./CardMenuSimple.vue?vue&type=script&lang=js"
export * from "./CardMenuSimple.vue?vue&type=script&lang=js"
script.render = render

export default script